import { FileText } from "lucide-react"
import { getIntlLocale } from "@/lib/i18n/format"

const isPDF = (url: string) => /\.pdf$/i.test(url)

function formatTime24h(timestamp?: string) {
  if (!timestamp) return undefined
  const d = new Date(timestamp)
  return d.toLocaleTimeString(getIntlLocale(), {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
}

function formatDateShort(timestamp?: string) {
  if (!timestamp) return undefined
  const d = new Date(timestamp)
  const dd = String(d.getDate()).padStart(2, "0")
  const mm = String(d.getMonth() + 1).padStart(2, "0")
  const yyyy = d.getFullYear()
  return `${dd}.${mm}.${yyyy}`
}

export function Thumbnail({
  url,
  fileName,
  documentType,
  timestamp,
  showDate,
  onClick,
}: {
  url: string
  fileName: string
  documentType?: string
  timestamp?: string
  showDate?: boolean
  onClick: () => void
}) {
  const pdf = isPDF(url)
  const time = formatTime24h(timestamp)
  const date = showDate ? formatDateShort(timestamp) : undefined
  return (
    <div className="flex flex-col items-center gap-0.5">
      <button
        className="group relative h-16 w-16 flex-shrink-0 overflow-hidden rounded-md border border-border bg-muted transition-all hover:ring-2 hover:ring-blue-400"
        onClick={onClick}
        title={fileName}
      >
        {pdf ? (
          <div className="flex h-full w-full items-center justify-center bg-red-50 dark:bg-red-950">
            <FileText className="h-8 w-8 text-red-500" />
          </div>
        ) : (
          <img
            src={url}
            alt={fileName}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        )}
      </button>
      {documentType && (
        <span className="max-w-[64px] truncate text-[10px] text-muted-foreground">
          {documentType}
        </span>
      )}
      {date && (
        <span className="text-[10px] text-muted-foreground">{date}</span>
      )}
      {time && (
        <span className="text-[10px] text-muted-foreground">{time}</span>
      )}
    </div>
  )
}

export { isPDF, formatTime24h, formatDateShort }
